// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1skPF","input":"styles_input__NUADc"};